import api from 'service/api'

const dponetAPI = api.create('guestPortal')

const get = async () => {
  return await dponetAPI.get('/dai_opt_out')
}

export default {
  get,
}
